export function isSellable(product, quantity) {
    if (product.quantity > 0 && quantity <= product.quantity)
        return true;
    if (product.quantity === 0)
        return product.availability.sellable;
    return false;
}
export const countDecimals = (quantity) => {
    if (Math.floor(quantity.valueOf()) === quantity.valueOf()) {
        return 0;
    }
    return quantity.toString().split('.')[1].length || 0;
};
